import domReady from '@wordpress/dom-ready';

domReady(() => {
  const backTopLimit = 200;
  let sticky = 80;
  let timer = null;

  function stickyNavbar() {
    const st = window.scrollY;
    if (st >= sticky) {
      document.body.classList.add('sticky-navbar');
    } else {
      document.body.classList.remove('sticky-navbar');
    }

    if (st <= backTopLimit) {
      document.body.classList.add('back-to-top-hidden');
    } else {
      document.body.classList.remove('back-to-top-hidden');
    }
    sticky = st + 40;
  }

  window.addEventListener('scroll', () => {
    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
      // actual callback
      stickyNavbar();
    }, 50);
  });

  stickyNavbar();
});
